const $ = jQuery.noConflict();

$(document).ready(function (){

  //console.log('gene script goes here');

});